import { Pipe, PipeTransform } from "@angular/core";
import { Injector, ElementRef, LOCALE_ID } from "@angular/core";
import { ColumnFormatService } from "@farris/ui-common/column";
import { FFileUtils } from "../utils/f-file.utils";
import { DateTimeHelperService } from "@farris/ui-common/date";
import { ColumnData } from "../model/column.model";
/**
 * 文件大小格式化
 */
@Pipe({
    name: "fFileSize",
})
export class FFileSizePipe implements PipeTransform {
    transform(value: any, args?: any): any {
        // 如果是字符串
        let tvalue = value;
        if (!value) {
            return "0 Byte";
        }
        if (typeof value == "string") {
            tvalue = parseInt(value);
        }
        return FFileUtils.humanizeBytes(tvalue);
    }
}
/**
 * 日期格式化
 */
@Pipe({
    name: "fFileDate",
})
export class FFileDatePipe implements PipeTransform {
    constructor(private dateSer: DateTimeHelperService) { }
    transform(value: any, returnFormat: string = "yyyy-MM-dd"): any {
        if(!value) return '';
        return this.dateSer.formatTo(value, returnFormat);
    }
}

/**
 * 格式化自定义数据
 */

@Pipe({ name: "formatCellData", pure: false })
export class FormatCellDataPipe implements PipeTransform {
    private elRef: ElementRef;
    // 先不处理多语言
    private localeId = "ZH-CHS";
    constructor(private cfs: ColumnFormatService, private injector: Injector) { }
    /**
     * 格式化数据
     * @param column:列信息
     * @param rowData:当前数据
     * @param settings:配置信息
     * @param state: 状态
     * @returns
     */
    transform(column, rowData, rowIndex, settings, state = "preview"): any {
        if (rowData && column && column.field) {
            // 值
            let value =this.getRealDataValue(rowData,column.field);
            let formatterFn = column.formatter;
            if (formatterFn) {
                if (formatterFn.type === "number") {
                    if (
                        !formatterFn.options ||
                        !Object.keys(formatterFn.options).length
                    ) {
                        formatterFn.options = {
                            thousand: ",",
                            precision: 2,
                        };
                    }
                }
                // 不需要特殊处理
                // if (formatterFn.type === "datetime") {
                // }
            }
            //参数1： 值，参数2：行数据 参数3：格式化方法
            return this.cfs.format(value, rowData, formatterFn, { rowIndex, settings });
        }
        return "";
    }
    /**
     * 获取真正的数据
     * @param rowData 
     * @param field 
     * @returns 
     */
    private getRealDataValue(rowData, field) {
        if (!field||!rowData) return '';
        let fieldArray = field.split('.');
        if (fieldArray.length == 1) {
            return rowData[fieldArray[0]];
        }
        let curItemVal = rowData;
        for (var k = 0; k < fieldArray.length; k++) {
            curItemVal = curItemVal[fieldArray[k]];
            // 没有值或者没有此属性
            if (curItemVal == null || curItemVal == undefined) {
                break;
            }
        }
        if (k == fieldArray.length) {
            return curItemVal == null || curItemVal == undefined?"":curItemVal;
        } else {
            return '';
        }
    }
    
}
/**
 * 附件可能之前生成的单据中并没有多语言服务
 * 调用附件的公共服务
 */
@Pipe({name: 'upLocale'})
export class UPLocalePipe implements PipeTransform {
    constructor() {}
    transform(name: any, ...replaceVal: any[]): any {
          return  FFileUtils.getLocalStr(name,replaceVal);
    }
}

/**
 * 解决变量有个默认的文字，变量最终可能是默认值也可能不是
 */
@Pipe({name: 'upLocaleDefault'})
export class UPLocaleDefaultPipe implements PipeTransform {
    constructor() {}
    transform(realValue: any,compareTxt:string,localeName:string): any {
        if(realValue==compareTxt){
            return  FFileUtils.getLocalStr(localeName);
        }
        return realValue;
    }         
}

@Pipe({name: 'upShowStar'})
export class UPShowRequiredStarPipe implements PipeTransform {
    constructor() {}
    transform(columnInfo: ColumnData): any {
        if (columnInfo['validators'] && columnInfo['validators'].length) {
            const isRequired = columnInfo['validators'].find(v => v.type === 'required');
            return isRequired;
        }else if(columnInfo['editor']&&columnInfo['editor']['type']&&columnInfo['editor']['validators']&&columnInfo['editor']['validators'].length>0){
            const isRequired = columnInfo['editor']['validators'].find(v => v.type === 'required');
            return isRequired;
        }
        return false;
    }
}

